var result = require("!!../../../../node_modules/html-loader/index.js?interpolate!./tabs.html")
var H = require("hogan.js");
window.Hogan = H;
module.exports = function() {
var T = H.compile(result, {});
return T; }();


//////////////////
// WEBPACK FOOTER
// ./node_modules/mustache-loader?noShortcut!./node_modules/html-loader?interpolate!./src/components/guideline/templates/tabs.html
// module id = 59
// module chunks = 0